import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import ActionTypes from './action-types';

export default handleActions(
    {
        [ActionTypes.AREA_FETCH_ALL_SUCCESS]: (state, {payload}) => state.merge(payload.areas),

        [ActionTypes.AREA_CREATE_SUCCESS]: (state, {payload}) => state.update(payload.area.areaId, () => payload.area),

        [ActionTypes.AREA_ADD_INSTITUTION_SUCCESS]: (state, {payload}) =>
            state.update(payload.area.areaId, () => payload.area),
        [ActionTypes.AREA_REMOVE_INSTITUTION_SUCCESS]: (state, {payload}) =>
            state.update(payload.area.areaId, () => payload.area),
    },
    Map(),
);
